import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Button from '../button';
import Component from '../component';

import SettingsMenuPanel from "./settings_menu_panel";

export default class SettingsButton extends Button {
  constructor(player, options = {}){
    super(player, options);
    this._adapter = new VideoJsAdapter();
    this._adapter._instance = player;

    this.settingsMenuPanel = new SettingsMenuPanel(player, this._adapter, options);
    this.el().appendChild(this.settingsMenuPanel.el());

    this.player().on("loadedmetadata", () => {
      document.addEventListener('click', 
        this.handleClickOutside.bind(this)
      );

      this.player().on('vp-episodes-list-open', () => {
        this.settingsMenuPanel.hide();
      });
    });
  }

  createEl() {
    var props = {
      innerHTML: '',
      className: this.buildCSSClass()
    };

    var el = Component.prototype.createEl.call(this, 'button', props);
    this.createControlTextEl(el);
    return el;
  }

  handleClick(e){
    e.stopPropagation();
    if(e.currentTarget === e.target) {
      this.toggleSettingsMenuPanel();
      this.player().trigger({ type: 'settings-button-click', data: { event: e } });
    }
  }

  handleClickOutside(e){
    e.stopPropagation();
    this.settingsMenuPanel.hide();
  }

  toggleSettingsMenuPanel() {
    this.settingsMenuPanel.toggle();
  }

  buildCSSClass() {
    return 'vjs-settings-button vjs-control vjs-button';
  }
}

SettingsButton.prototype.controlText_ = "Playback Settings"
VideoJsAdapter.registerComponent('VpSettingsButton', SettingsButton);